export default __webpack_public_path__ + "static/media/sample_route_map.b7d4e008.png";